import { css } from "@emotion/react";
import { CustomSkeleton } from "../CustomSkeleton";
import { codeTopPadding, exampleTopPadding } from "../../styles/padding.styles";
import { SubHeader } from "../headers/SubHeader";
import { CanvasLoading } from "./CanvasLoading";

export const RouteDetailLoading = () => {
    return (
        <div
            css={css`
                padding: 2rem;
            `}
        >
            <div>Web SDK: {WEB_SDK_FULL_VERSION}</div>
            <CustomSkeleton width="400px" height={48} style={{ margin: "8px 0" }} />
            <br />
            <br />
            <CustomSkeleton width="20%" height={32} />
            <br />
            <CustomSkeleton width="80%" paragraph={3} />
            <br />
            <br />
            <CustomSkeleton width="30%" paragraph={3} />
            <div css={exampleTopPadding}>
                <CanvasLoading />
            </div>
            <div css={codeTopPadding}>
                <SubHeader text="Code" />

                <CustomSkeleton paragraph={5} />
            </div>
        </div>
    );
};
